import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useNavigate } from 'react-router-dom';
import EventsApi from '../../../api/eventsApi/eventsApi';

interface DeletionModalProps {
    open: boolean;
    onClose: () => void;
    pinId: string;
}

const DeletionModal: React.FC<DeletionModalProps> = ({ open, onClose, pinId }) => {
    const navigate = useNavigate();

    const handleDelete = async () => {
        try {
            await EventsApi.deletePin(pinId);
            navigate('/reports');
        } catch (error) {
            console.error('Pin silinirken hata oluştu:', error);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    p: 2
                }
            }}
        >
            <DialogTitle sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 2,
                color: '#d32f2f'
            }}>
                <WarningIcon fontSize="large" />
                <Typography variant="h6" component="span">
                    Silme İşlemi Onayı
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ py: 2 }}>
                    <Typography>
                        Bu tesisi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        backgroundColor: '#fff',
                        color: '#094151',
                        border: '1.5px solid #094151',
                        fontWeight: 600,
                        borderRadius: '8px',
                        boxShadow: 'none',
                        '&:hover': {
                            backgroundColor: '#d0e7ec',
                            color: '#094151',
                        }
                    }}
                >
                    Geri
                </Button>
                <Button
                    onClick={handleDelete}
                    variant="contained"
                    sx={{
                        backgroundColor: '#d32f2f',
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: '#b71c1c',
                        }
                    }}
                >
                    Sil
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeletionModal; 